import { MUTATION_USER_PREFERENCES } from "./types";

export default {
    [MUTATION_USER_PREFERENCES]: (state, payload) => {
        state.userPreferences = payload || {};
    }
}